import { useState, useEffect } from 'react';

const faqs = [
  {
    q: 'Qual a diferença entre solda por cunha quente e solda por extrusão?',
    a: 'A solda por cunha quente funde as superfícies internas de duas camadas sobrepostas de geomembrana utilizando uma cunha metálica aquecida, seguida de rolos de pressão. É o método mais rápido e adequado para costuras lineares. A solda por extrusão utiliza um cordão de material termoplástico fundido depositado sobre a junta, sendo indicada para reparos, detalhes geométricos e situações onde a cunha quente não consegue acessar.',
  },
  {
    q: 'Qual máquina é recomendada para obras de grande escala?',
    a: 'Para obras de grande escala como aterros sanitários e barragens, recomenda-se máquinas de alta produtividade como a BT950 (até 8 m/min, 2100W) e a Weldy WGW300 (até 9 m/min, 2100W). Estes modelos oferecem maior velocidade de solda e robustez para operação contínua em campo.',
  },
  {
    q: 'Posso soldar diferentes tipos de geomembrana com a mesma máquina?',
    a: 'Sim. As máquinas de cunha quente da SoldaGeo possuem controle digital de temperatura que permite ajuste preciso para diferentes materiais termoplásticos como PEAD, PELBD, PVC e PP. Basta configurar a temperatura adequada para cada tipo de geomembrana conforme a recomendação do fabricante do material.',
  },
  {
    q: 'Qual a espessura máxima de geomembrana que posso soldar?',
    a: 'Depende do modelo. A BT800 trabalha com materiais de 500 a 1500 mic, enquanto a BT950 e a Weldy WGW300 alcançam até 3000 mic. Para aplicações específicas, consulte nossa equipe técnica para orientação personalizada.',
  },
  {
    q: 'As máquinas acompanham garantia e suporte técnico?',
    a: 'Sim. Todos os equipamentos comercializados pela SoldaGeo possuem garantia de fábrica (6 ou 12 meses conforme o modelo) e suporte técnico especializado. Nossa equipe oferece orientação completa sobre operação, manutenção e melhores práticas de soldagem.',
  },
  {
    q: 'Vocês enviam para todo o Brasil?',
    a: 'Sim. A SoldaGeo realiza entregas para todos os estados brasileiros com transporte seguro e prazo ágil. Consulte-nos para verificar a disponibilidade do modelo desejado e o prazo de entrega para sua região.',
  },
  {
    q: 'Qual a diferença entre as máquinas BT800, BT1600 e BT950?',
    a: 'A principal diferença está na potência e na espessura de geomembrana suportada. A BT800 (800W) solda materiais de 0,5 a 1,5 mm, ideal para obras menores. A BT1600 (1600W) atende de 0,4 a 2,0 mm para projetos de médio porte. A BT950 (2100W) é o modelo mais potente, soldando até 3,0 mm para grandes obras como aterros e mineração.',
  },
  {
    q: 'Qual máquina de solda de geomembrana escolher para o meu projeto?',
    a: 'A escolha depende do material, da espessura da geomembrana e do tipo de obra. Para grandes áreas planas como aterros sanitários e barragens, recomenda-se a BT950 ou a Weldy WGW300. Para obras menores e locais de difícil acesso, a BT800 é a opção mais compacta. Nossa equipe técnica ajuda a definir o modelo ideal para o seu projeto.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  useEffect(() => {
    const existing = document.getElementById('maquinas-faq-schema');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'maquinas-faq-schema';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a,
        },
      })),
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('maquinas-faq-schema');
      if (s) s.remove();
    };
  }, []);

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-green-600 text-xs font-black uppercase tracking-[0.2em]">
            Dúvidas Comuns
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 uppercase mt-3 mb-4">
            Perguntas Frequentes
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl border border-gray-100 overflow-hidden transition-all duration-300"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => toggle(idx)}
              >
                <span className="text-sm font-black text-gray-900 pr-4">
                  {faq.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-green-600 text-lg" />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-gray-500 text-sm leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}